'use client';

import type { TextShimmerProps } from './const';
import { forwardRef, useMemo } from 'react';
import { cn } from '../../utils/classNames';
import './index.less';

function TextShimmer(
  {
    children,
    as: Component = 'p',
    className,
    style,
    duration = 2,
    spread = 100,
    delay = 0,
  }: TextShimmerProps,
  ref: React.Ref<HTMLElement>,
) {
  const customStyle = useMemo(() => ({
    '--wg-shimmer-duration': `${duration}s`,
    '--wg-shimmer-spread': `${spread}px`,
    '--wg-shimmer-delay': delay > 0 ? `${delay}s` : '0s',
    ...style,
  } as React.CSSProperties), [duration, spread, delay]);

  return (
    <Component
      ref={ref}
      className={cn('wg-text-shimmer', className)}
      style={customStyle}
    >
      {children}
    </Component>
  );
}

const TextShimmerComponent = forwardRef<HTMLElement, TextShimmerProps>(TextShimmer);

TextShimmerComponent.displayName = 'TextShimmer';

export default TextShimmerComponent;
export type { TextShimmerProps };
